import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/card';
import { ExternalLink } from 'lucide-react';

const AboutAprilSection = () => {
  const imageRef = useRef(null);

  // Parallax effect removed for better image visibility

  return (
    <section id="about" className="section-spacing section-sage-mist">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Decorative line */}
        <div className="decorative-line max-w-24 mx-auto mb-16"></div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <Card className="overflow-hidden shadow-warm-lg">
            <div className="grid lg:grid-cols-[45%_55%] gap-0">
              {/* Photo - 45% */}
              <div className="relative aspect-square lg:aspect-auto overflow-hidden rounded-2xl">
                <img 
                  ref={imageRef}
                  src="/april-jackson-new.jpg"
                  alt="April Jackson - Podcast Host"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Bio - 55% */}
              <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center">
                <p className="label-uppercase mb-4">Your Host</p>
                <h2 className="text-4xl sm:text-5xl font-normal mb-6">
                  Meet April Jackson
                </h2>
                
                <div className="flex flex-wrap gap-3 mb-8">
                  <span className="credential-pill">BBC Presenter</span>
                  <span className="credential-pill">Entrepreneur</span>
                  <span className="credential-pill">Former Miss Universe Jamaica</span>
                </div>

                <div className="space-y-5 text-muted-foreground leading-relaxed text-lg">
                  <p>
                    April Jackson knows what it means to reinvent yourself. As a BBC presenter, entrepreneur, and former Miss Universe Jamaica, she's lived multiple lives across continents.
                  </p>
                  <p>
                    Through <strong className="text-foreground">A Life Elsewhere</strong>, April explores the raw, unfiltered stories of people who've left everything familiar to build new lives abroad. Each conversation dives deep into the challenges, triumphs, and profound transformations that come with starting over.
                  </p>
                  <p className="italic text-primary font-medium">
                    "The courage to begin again exists in all of us. Belonging isn't about where you're from, it's about who you choose to become."
                  </p>
                </div>

                <div className="mt-10 flex flex-wrap gap-6">
                  <a 
                    href="https://www.instagram.com/a_life_elsewhere" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-primary hover:underline flex items-center gap-1.5"
                  >
                    Instagram <ExternalLink className="w-3.5 h-3.5" />
                  </a>
                  <a 
                    href="https://www.tiktok.com/@April_Jackson_Show" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-primary hover:underline flex items-center gap-1.5"
                  >
                    TikTok <ExternalLink className="w-3.5 h-3.5" />
                  </a>
                  <a 
                    href="https://www.youtube.com/@ALifeElsewhere" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-sm font-medium text-primary hover:underline flex items-center gap-1.5"
                  >
                    YouTube <ExternalLink className="w-3.5 h-3.5" />
                  </a>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutAprilSection;